import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetEnglishIqResultV1Request } from './get-english-iq-result-v1-request';
import type { IGetEnglishIqResultV1Response } from './get-english-iq-result-v1-response';
import { getEnglishIqResultV1ResponseSchema } from './get-english-iq-result-v1-response';

export async function getEnglishIqResultV1Api(
  request: IGetEnglishIqResultV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetEnglishIqResultV1Response>> {
  return getRequest<IGetEnglishIqResultV1Response>({
    options,
    path: `/english-iq/result/${encodeURIComponent(request.shareId)}/v1`,
    schema: getEnglishIqResultV1ResponseSchema,
  });
}
